'use client';

import { memo as Memo, useRef, useEffect, useState, useCallback } from 'react';

//* HOC's
import withUIContext from '@context/consumerHOC/UIConsumer';

//* Components
import Page from '@components/global/Page';
import Awards from '@components/global/Awards';
import TableItem from '@components/global/TableItem';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/global/PageTopSection';
import ZiggyAwards from '@components/global/SvgComponents/ZiggyAwards';

const AwardsPage = Memo(({ pageData, winHeight }) => {
	//! States
	const [secObj, setSecObj] = useState({
		sec1: false,
		sec2: false,
	});

	//! Refs
	const sec1 = useRef();
	const sec2 = useRef();

	//! Animation
	const sectionAnimation = useCallback(() => {
		let arr = [];

		if (sec1.current) {
			arr = [sec1?.current?.getBoundingClientRect(), sec2?.current?.getBoundingClientRect()];

			let newObj = secObj;
			for (let i = 0; i < arr.length; i++) {
				newObj = { ...newObj, [`sec${i + 1}`]: arr[i].top < winHeight };
			}

			if (JSON.stringify(secObj) !== JSON.stringify(newObj)) {
				setSecObj(newObj);
			}
		}
	}, [sec1, sec2, secObj, winHeight]);

	useEffect(() => {
		sectionAnimation();
	}, [sec1.current, sec2.current]);

	useEffect(() => {
		window.addEventListener('scroll', sectionAnimation);

		return () => {
			window.removeEventListener('scroll', sectionAnimation);
		};
	}, [sec1, sec2, secObj, winHeight]);

	return (
		<Page>
			<HTMLContainer className={`ov-hidden`}>
				<div className='section-item'>
					<PageTopSection {...pageData.hero} />

					<div ref={sec1}>
						<TableItem
							underlie
							active={secObj.sec1}
							className={'one-item'}
							animation={<ZiggyAwards />}
							title={pageData.info.title}
							details={pageData.info.details}
							description={pageData.info.description}
						/>
					</div>
				</div>

				<div
					ref={sec2}
					className='section-item'>
					<Awards
						type={1}
						active={secObj.sec2}
					/>
				</div>
			</HTMLContainer>
		</Page>
	);
});

export default withUIContext(AwardsPage, ['winHeight']);
